import __base_store from '@/store/__base_store'

/**
 * Store de movimientos de caja (modelo `movimiento_caja`) construido desde el factory común.
 */
export default __base_store({
	state: {
		model_name: 'movimiento_caja',
	},
})

